import { validaCPF } from 'helpers/utils/cpfCnpjMask';
import {
  DEFAULT_VALID,
  DEFAULT_VALIDATION_MODEL,
} from 'helpers/utils/ValidationUtils';

export interface ValidatorProps {
  allIsValid: () => {
    error: boolean;
    helperText: string;
  };
  nameIsValid: () => {
    error: boolean;
    helperText: string;
  };
  CpfIsValid: () => {
    error: boolean;
    helperText: string;
  };
  CpfAllPresent: () => {
    error: boolean;
    helperText: string;
  };
}

export const ConfirmarPresencaModalValidator = (nameOrCpf: string) => {
  const validator: any = {};

  validator.nameIsValid = () => {
    const value = nameOrCpf;

    let twoWords = /[a-zA-Z]+\s+[a-zA-Z]+/g;
    if (!twoWords.test(value)) {
      return DEFAULT_VALIDATION_MODEL(true, 'Nome e sobrenome são necessários');
    }
    return DEFAULT_VALID;
  };

  validator.CpfIsValid = () => {
    const value = nameOrCpf;
    if (!validaCPF(value)) {
      return DEFAULT_VALIDATION_MODEL(true, 'CPF inserido não é válido');
    }
    return DEFAULT_VALID;
  };

  return validator;
};
